import http from "../../../utils/services/http-client";
import {EditProductModel, RegisterProductModel} from "../models";

class AdInsertService {
  getProductAssurance(productId:number) {
    return http.get(`/ProductAssurance?productCategoryId=` + productId);
  }
  getProductProperties(id:number) {
    return http.get(`/ProductProperties?productSubCategoryId=`+id);
  }
  getProductConditions(id:number) {
    return http.get(`/ProductCondition?productSubCategoryId=`+id);
  }
  registerProduct(model:RegisterProductModel) {
    return http.post(`/Product`,model);
  }
  editProduct(model:EditProductModel) {
    return http.put(`/Product`,model);
  }


}

export default new AdInsertService();
